<template>
  <v-menu
      v-if="username"
      :close-on-content-click="false"
      offset-y
      v-model="showAccountDropdownActions"
      z-index="1002"
  >
    <template v-slot:activator="{ on, attrs }" v-if="pagesize > 767">
      <v-btn v-bind="attrs" v-on="on" light text right color="white" class="login btn">
        <span class="icon icon-login"/>
        {{ username }}
        <v-icon large>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <template v-slot:activator="{ on, attrs }" v-else>
      <v-btn v-bind="attrs" v-on="on" light text x-large icon color="white">
        <v-icon x-large>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-list flat>
      <v-subheader><span class="account-header">Mein Portalkonto</span></v-subheader>
      <v-navigation-drawer v-model="drawerActive" absolute width="100%" class="pt-2">
        <v-subheader>
          <span class="account-header">{{ drawerTitle }}</span>
          <v-spacer></v-spacer>
          <v-icon left @click="closeDrawer">mdi-chevron-left</v-icon>
        </v-subheader>
        <v-list flat>
          <v-list-item v-for="child in drawerItems" :key="child.text" link @click="child.action(child)">
            <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-list-item link v-for="item in listItems" :key="item.text" @click="item.action(item)">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-if="item.items">
          <v-icon left @click="drawerActive = false">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {mapGetters} from 'vuex';
import {metadataClient} from '@/js/helpers/backend-clients';

export default {
  name: 'NavbarAccountActionsComponent',
  data() {
    return {
      showAccountDropdownActions: false,
      drawerActive: false,
      drawerTitle: '',
      drawerItems: [],
      listItems: this.buildListItems(),
    };
  },
  computed: {
    ...mapGetters({
      username: 'user/username',
      pagesize: 'pagesize',
      links: 'links',
    }),
  },
  methods: {
    navigateTo(dest) {
      this.$router.push(dest);
    },
    closeDrawer() {
      this.drawerActive = false;
      this.drawerItems = [];
      this.drawerTitle = '';
    },
    openDrawer(title, items) {
      this.drawerTitle = title;
      this.drawerItems = items;
      this.drawerActive = true;
    },
    loadPage(page) {
      window.open(page, '_blank', 'resizable=1');
    },
    ladeHilfeLink(type) {
      metadataClient.ladeHilfeLink(type).then(({data}) => {
        this.loadPage(data);
      });
    },
    optionalTexts() { // Filter optional texts, that might or might not be there!
      return [this.$store.getters['links'].nutzungsbedingungen].map(link => this.optionalText(link)).filter(item => item !== undefined);
    },
    optionalText(link) {
      let result;
      if (link !== null && link !== undefined && link.length > 0) {
        result = {
          icon: 'mdi-link',
          text: 'Allgemeine Geschäftsbedingungen',
          action: () => this.loadPage(link),
        };
      } else {
        result = undefined;
      }
      return result;
    },
    productHelpTexts() {
      return Object.entries(this.$store.getters['links']?.products).map(product => this.productHelpTextDrawer(product));
    },
    productHelpTextDrawer(product) {
      return {
        icon: 'mdi-folder',
        text: product[0],
        items: [...this.productItems(product[1])],
        action: item => this.openDrawer(item.text, item.items)
      };
    },
    productItems({leitfadenLink, leistungsbeschreibungLink}) {
      return [
        {
          icon: 'mdi-link',
          text: 'Leitfaden',
          action: () => this.loadPage(leitfadenLink),
        },
        {
          icon: 'mdi-link',
          text: 'Leistungsbeschreibung',
          action: () => this.loadPage(leistungsbeschreibungLink),
        },
      ];
    },
    buildListItems() {
      return [
        {
          icon: 'mdi-file-document-plus-outline',
          text: 'Zurück zur Gutachtenauswahl',
          action: () => {
            this.showAccountDropdownActions = false;
            this.$store.dispatch('gutachten/reset');
            this.$store.dispatch('objektbesichtigung/reset');
            this.$store.dispatch('kaufpreisaufteilung/reset');
            this.$store.dispatch('product/reset');
            this.$store.dispatch('address/clearAddress', null, {root: true}).then();
            this.navigateTo('/gutachtenauswahl');
          },
        },
        {
          icon: 'mdi-lock-reset',
          text: 'Passwort ändern',
          action: () => {
            this.showAccountDropdownActions = false;
            this.navigateTo('/passwort-aendern');
          },
        },
        {
          icon: 'mdi-file-document-outline',
          text: 'Meine Gutachten',
          action: () => {
            this.showAccountDropdownActions = false;
            this.navigateTo('/meine-gutachten');
          },
        },
        {
          icon: 'mdi-content-save-outline',
          text: 'Gespeicherte Aufträge',
          action: () => {
            this.showAccountDropdownActions = false;
            this.navigateTo('/meine-auftraege');
          },
        },
        {
          icon: 'mdi-comment-question-outline',
          text: 'Hilfe & Support',
          items: [
            {
              icon: 'mdi-link',
              text: 'Support',
              action: () => this.ladeHilfeLink('SUPPORT'),
            },
            {
              icon: 'mdi-link',
              text: 'SEPA-Lastschriftmandat',
              action: () => this.ladeHilfeLink('SEPA'),
            },
            ...this.optionalTexts(),
            ...this.productHelpTexts()
          ],
          action: item => this.openDrawer(item.text, item.items),
        },
        {
          icon: 'mdi-logout',
          text: 'Logout',
          action: () => {
            this.showAccountDropdownActions = false;
            this.$store.dispatch('user/logout');
          },
        },
      ];
    }
  },
  watch: {
    links: {
      handler() { // Links might not be loaded on startup, so we need to watch for changes and build the array new!
        this.listItems = this.buildListItems();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.account-header {
  font-size: 1.3rem;
  font-weight: bold;
}
</style>
